import { useEffect, useState } from "react";
import Layout from "../components/Layout";
import DossierCard from "../components/DossierCard";
import api from "../lib/api";
import { useZoom } from "../context/ZoomContext";

export default function Dossiers() {
  const [dossiers, setDossiers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { gridClass } = useZoom();

  useEffect(() => {
    api.get("/dossiers")
      .then((r) => setDossiers(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <section className="px-4 md:px-6 pt-10 pb-6">
        <div className="label-overline mb-3">// INDEX OF DOSSIERS</div>
        <h1 className="heavy text-5xl sm:text-6xl md:text-7xl">All Dossiers.</h1>
      </section>
      <section className="px-2 md:px-3 pb-16">
        {loading ? (
          <div className="mono text-ink-muted px-4">// loading…</div>
        ) : dossiers.length === 0 ? (
          <div className="hairline p-12 text-center mx-2">
            <div className="heavy text-3xl">No dossiers archived yet.</div>
          </div>
        ) : (
          <div data-testid="dossiers-page-grid" className={`grid ${gridClass} gap-2 md:gap-3`}>
            {dossiers.map((d) => <DossierCard key={d.id} dossier={d} />)}
          </div>
        )}
      </section>
    </Layout>
  );
}
